import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate, useNavigationType, useLocation } from 'react-router-dom';
import './group.css'
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import VoucherAlter from '../../alter/accounting_masters/VouchersType';
import VoucherView from '../../view/accounting_masters/VouchersTypeView';
import { useDropdownKeyboardNavigation } from '../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../../../../components/Custom_Hooks/useDropdownScroll';
import HomeLayout from '../../../../../components/home_page/HomeLayout';
import Form from '../../../../../components/Form/Form';
import NavFooterLayout from '../../../../../components/NavNameOfComponent/NavFooterLayout';
import VoucherCreate from '../../create/accounting_masters/VouchersType';
import DeletConfirm from '../../../../../components/Modal/DeletConfirm';
import { useDelet } from '../../../../../components/Custom_Hooks/useDelete';
import { prepareFormData } from '../../../../../components/Custom_Hooks/useFormHandler';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import { voucherTypeList, voucherTypeDelete, closeModal, openModal, saveChartOfAccountsState } from '../../../../../redux/actions/action-creator';


function VouchersType() {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [all_data, setall_data] = useState([]);

    const { userData = null } = useSelector(state => state.auth);
    const modal_state = useSelector(state => state.common.modal_state);
    const persistedState = useSelector(state => state.common.chart_of_accounts_persisted_state?.vouchersType);
    const navigationType = useNavigationType();
    const location = useLocation();
    const isBackNavigation = navigationType === 'POP';
    const localSelectionRef = useRef(null);
    const boxRef = useRef(null);
    const [enabled, setEnabled] = useState(true);

    // fetching data -----------------------------
    useEffect(() => {
        setEnabled(true);
        const fetchData = async () => {
            try {
                const formdata = new FormData();
                formdata.append('company_id', userData?.id);
                const response = await dispatch(voucherTypeList(formdata));
                if (response.status) {
                    const sortedData = [...response.data].sort((a, b) => {
                        const nameA = (a.voucher_type_name || "").toLowerCase();
                        const nameB = (b.voucher_type_name || "").toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    });
                    setall_data(sortedData);
                    const itemNameToRestore = isBackNavigation ? persistedState?.selectedItemName : localSelectionRef.current;
                    if (itemNameToRestore) {
                        const index = sortedData.findIndex(item => (item.voucher_type_name || item.name) === itemNameToRestore);
                        if (index !== -1) setSelectedItemIndex(index);
                        else setSelectedItemIndex(0);
                    } else {
                        setSelectedItemIndex(0);
                    }
                    //setall_data(response.data)
                    setLoading(false)
                } else {
                    console.log("response failed", response)
                }
            } catch (error) {
                console.error('Error fetching group data:', error);
            } finally {
                setLoading(false);

            }
        };
        fetchData();
    }, [location, modal_state?.voucher_type_view, modal_state?.voucher_type_update, modal_state?.voucher_type_create, modal_state?.voucher_type_delete])

    // keyboard Functionality ----------------------------------------
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: modal_state?.voucher_type_view || modal_state?.voucher_type_update || modal_state?.voucher_type_create || modal_state?.voucher_type_delete ? false : true,
        initialIndex: 0,
        enableAlphaJump: true,
        getLabel: (item) => item?.voucher_type_name || '',
        onItemSelect: (item) => {
            if (!(modal_state?.voucher_type_create || modal_state?.voucher_type_delete || modal_state?.voucher_type_update)) {
                // navigate(`../alter_accounting_groupupdate/${item?.data?.id}`)
                dispatch(saveChartOfAccountsState({ vouchersType: { selectedItemName: item?.voucher_type_name, selectedItemIndex } }));
                dispatch(openModal('voucher_type_view'))
            }
        },
        onItemControlEnterSelect: (item) => {
            if (!(modal_state?.voucher_type_create || modal_state?.voucher_type_delete || modal_state?.voucher_type_view)) {
                // navigate(`../alter_accounting_groupupdate/${item?.data?.id}`)
                dispatch(saveChartOfAccountsState({ vouchersType: { selectedItemName: item?.voucher_type_name, selectedItemIndex } }));
                dispatch(openModal('voucher_type_update'))
            }
        },
        onItemAltCSelect: (item) => {
            if (!(modal_state?.voucher_type_update || modal_state?.voucher_type_delete || modal_state?.voucher_type_view)) {
                dispatch(saveChartOfAccountsState({ vouchersType: { selectedItemName: item?.voucher_type_name, selectedItemIndex } }));
                dispatch(openModal('voucher_type_create'))
            }
        },
        onItemAltDSelect: (item) => {
            if (!(modal_state?.voucher_type_update || modal_state?.voucher_type_delete || modal_state?.voucher_type_view)) {
                dispatch(saveChartOfAccountsState({ vouchersType: { selectedItemName: item?.voucher_type_name, selectedItemIndex } }));
                dispatch(openModal('voucher_type_delete'))
            }
        },
    });

    useEffect(() => {
        if (selectedItemIndex !== undefined && all_data[selectedItemIndex]) {
            const currentItem = all_data[selectedItemIndex];
            const name = currentItem.voucher_type_name || currentItem.name;
            localSelectionRef.current = name;
            if (name && !modal_state?.voucher_type_view && !modal_state?.voucher_type_update && !modal_state?.voucher_type_create && !modal_state?.voucher_type_delete) {
                dispatch(saveChartOfAccountsState({ vouchersType: { selectedItemName: name, selectedItemIndex } }));
            }
        }
    }, [selectedItemIndex, all_data]);
    // Scroll Functionality -------------------------------------
    useDropdownScroll({ boxRef, selectedItemIndex });

    const [data, setData] = useState({
        id: all_data[selectedItemIndex]?.id,
        company_id: userData?.id
    })

    useEffect(() => {
        if (all_data[selectedItemIndex]) {
            setData({
                id: all_data[selectedItemIndex]?.id,
                company_id: userData?.id,
            });
        }
    }, [selectedItemIndex, all_data]);

    // Delete Functionality ------------------------------
    const { delteItem, loadingDelete } = useDelet({
        prepareFormData: () => prepareFormData(data),
        submitForm: (data) => dispatch(voucherTypeDelete(data)),
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => delteItem(new Event('submit')),
            },
        ],
        closeModal: () => dispatch(closeModal('voucher_type_delete')),
        state: modal_state?.voucher_type_delete
    });
    //console.log(all_data);
    return (
        <HomeLayout>
            {modal_state?.voucher_type_create && (
                <div style={{ zIndex: 10000 }}>
                    <VoucherCreate
                        title='Voucher Type Creation (Primary)'
                        closeModal_sec={() => dispatch(closeModal('voucher_type_create'))}
                    />
                </div>)}
            {
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.voucher_type_update
                && (
                    <div style={{ zIndex: 10000 }}>
                        <VoucherAlter
                            data_to_update={data}
                            title='Voucher Type Alteration'
                            closeModal_sec={() => dispatch(closeModal('voucher_type_update'))}
                        />
                    </div>
                )}
            {
                modal_state?.voucher_type_view
                && (
                    <div style={{ zIndex: 10000 }}>
                        <VoucherView
                            data_to_view={data}
                            title='Voucher Type View'
                            closeModal_sec={() => dispatch(closeModal('voucher_type_view'))}
                        />
                    </div>
                )}
            <Form
                title='List of Voucher Types'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={enabled}
            >
                {
                    modal_state?.voucher_type_delete ?
                        <div style={{ zIndex: 10000 }}>
                            <DeletConfirm
                                handleSubmit={delteItem}
                                loading={loadingDelete}
                                closeModal={() => dispatch(closeModal('voucher_type_delete'))}
                            />
                        </div>
                        : null
                }
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom  mt-0 ">
                    <div
                        className="col-1 font_size p-0 m-0 ps-3 text-end fw-bold"
                        style={{ width: "3%" }}
                    >
                        Sr
                    </div>
                    <div
                        className={`col-7 font_size p-0 m-0 ps-3 text-start fw-bold`}
                    >
                        Name of Voucher
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 ps-3 text-start fw-bold"
                    >
                        Voucher Number
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 ps-3 text-start fw-bold"
                    >
                        Abbreviation
                    </div>
                </div>
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={boxRef} style={{ overflowY: 'auto', height: '78.3vh' }}>
                        {
                            all_data.map((item, index) => {
                                return (
                                    /*<div
                                        key={index}
                                        className={index === selectedItemIndex ? 'selected' : ''}
                                        style={{
                                            display: 'flex',
                                            textAlign: 'left',
                                            paddingLeft: 5,
                                        }}
                                    >
                                        <Link
                                            onClick={() => setSelectedItemIndex(index)}
                                            className={'group_list_chart_of_account'}
                                            style={{ width: '100%' }}
                                        >
                                            {item.voucher_type_name}
                                        </Link>
                                    </div>*/

                                    <div
                                        key={index}
                                        onClick={() => setSelectedItemIndex(index)}
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        className={`row gx-0 p-0 m-0  mt-0 ${index === selectedItemIndex ? "selected" : ""}`}>
                                        <div
                                            className="col-1 font_size p-0 m-0 ps-3 text-end"
                                            style={{ width: "3%" }}
                                        >
                                            {index + 1}
                                        </div>
                                        <div
                                            className={`col-7 font_size p-0 m-0 ps-3 text-start`}
                                        >
                                            {item?.voucher_type_name}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 ps-3 text-start"
                                        >
                                            {item?.method_of_voucher_number}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 ps-3 text-start"
                                        >
                                            {item?.abbreviation}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <NavFooterLayout>
                    <b className='ps-2'> {all_data.length} Voucher Type(s)</b>
                </NavFooterLayout>

            </Form>
        </HomeLayout>
    )
}

export default VouchersType;
